import { render, staticRenderFns } from "./ReporteFactura.vue?vue&type=template&id=84d7ba8c&scoped=true"
import script from "./ReporteFactura.vue?vue&type=script&lang=js"
export * from "./ReporteFactura.vue?vue&type=script&lang=js"
import style0 from "./ReporteFactura.vue?vue&type=style&index=0&id=84d7ba8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d7ba8c",
  null
  
)

export default component.exports